import React, {useRef, useEffect, useState, useMemo} from 'react';
import Cropper from './Cropper';
import {Avatar} from './Avatar';
import useUser from '../hooks/useUser';
import { useTranslation } from 'react-i18next';
import debounce from 'lodash.debounce';

const RemoveImageBtn = ({onClick}) => {
  const {t} = useTranslation('lounge')
  return (
    <button
      className="font-bold text-center text-sm text-red-500 w-full pt-2 pb-1"
      onClick={onClick}>
      <i className="fas fa-trash fa-fw" /> {t('remove-profile-picture')}
    </button>
  );
};

export default function AvatarUpload({onChangeImage, image, setImage, type, value}) {
  const {t} = useTranslation('lounge')
  const cropperRef = useRef(null);
  const inputFileRef = useRef(null)
  const user = useUser();

  useEffect(() => {
    if (image && image.src && !image.result) {
      onChangeImage(image)
      onCrop();
    }
  }, [image]);


  const onCrop = useMemo(() => debounce(() => {
    if (
      image &&
      cropperRef.current &&
      typeof cropperRef.current.cropper.getCroppedCanvas !== 'undefined'
    ) {
      const result = cropperRef.current.cropper.getCroppedCanvas({
        maxWidth: 500,
      });

      if (result) {
        result.toBlob(blob => {
          const file = new File([blob], 'profile.png', {type: blob?.type});
          onChangeImage(file);
        }, 'image/png');
      }
    }
  }, 500), [cropperRef.current, image]);

  const resetImage = e => {
    e.stopPropagation();
    setImage(false);
    onChangeImage(false)
  };

  const onFileChange = e => {
    e.preventDefault();

    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    var canvas = document.createElement("canvas");
    var context = canvas.getContext('2d');
    var maxW = 2500;
    var maxH = 2500;
    var img = new Image();
    img.src = URL.createObjectURL(files[0]);

    img.onload = function() {
      var iw = img.width;
      var ih = img.height;
      var scale = Math.min((maxW / iw), (maxH / ih));
      var iwScaled = iw * scale;
      var ihScaled = ih * scale;
      canvas.width = iwScaled;
      canvas.height = ihScaled;
      context.drawImage(img, 0, 0, iwScaled, ihScaled);

      setImage({
        src: canvas.toDataURL(),
        file: files[0],
        filename: files[0].name,
        filetype: files[0].type,
        result: null,
      });
    }
  };

  return (
    <div className="avatar-cropper mb-2">
      {!image ? (
        <div>
          <Avatar 
            initial={value} 
            user={user} 
            character={user?.name?.charAt()} 
            onClick={() => inputFileRef.current.click()} 
            disabled={!!value}
            containerStyle={`w-16 h-16 lg:w-20 lg:h-20`}
            textSize={`text-lg`}
          />
          {value ? (
            <RemoveImageBtn onClick={e => resetImage(e)} />
          ) : (
            <input
              ref={inputFileRef}
              className="input-avatar"
              type="file"
              accept="image/*"
              onChange={onFileChange}
              style={{'--text': `'${t('upload-profile-picture')}'`}}
            />
          )}
        </div>
      ) : (
        <div>
          {type !== 'guest' && (
            <div className="mb-2">
              <button
                className="text-yellow-500 hover:underline text-sm font-semibold"
                onClick={e => resetImage(e)}>
                <i className="fas fa-chevron-left fa-fw" aria-hidden="true"></i>{' '}
                {t('back')}
              </button>
            </div>
          )}
          <Cropper image={image} onCrop={onCrop} cropperRef={cropperRef} />
          {type === 'guest' && (
            <RemoveImageBtn onClick={e => resetImage(e)} />
          )}
        </div>
      )}
    </div>
  );
}
